module.exports = __webpack_public_path__ + "img/img_carousel.67fedae2.webp";